<template>
  <div class="footer">
    <div class="footer__inner">
      <div>
        有帮信息科技（北京）有限公司
      </div>
      <div>
        <span>© Copyright 2021 - {{ year }}</span>
        <span class="split">|</span>
        <span>京ICP备2021028839号-1</span>
      </div>
    </div>
  </div>
</template>

<script>
import {defineComponent} from 'vue'

export default defineComponent({
  setup() {
    return {
      year: (new Date()).getFullYear()
    }
  }
})
</script>

<style lang="scss" scoped>
.footer {
  display: flex;
  justify-content: center;
  align-items: center;
  border-top: 1px solid #eee;

  padding-top: 15px;
  padding-bottom: 15px;

  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  color: rgba(122, 122, 122, 0.65);
}
.footer__inner {
  text-align: center;
}
.split {
  margin-left: 15px;
  margin-right: 15px;
}
</style>
